import { getProjectInvoiceStateColor, getProjectInvoiceStateString } from "@msuite/utils/projects";
import type { Tables } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import { Tag } from "./tag";

/** Props Interface */
interface InvoiceStateTagProps {
	state: Tables<"outgoingInvoices">["state"];
}

export function InvoiceStateTag({ state }: InvoiceStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			variant="plain"
			color={getProjectInvoiceStateColor(state)}
		>
			{t(getProjectInvoiceStateString(state))}
		</Tag>
	);
}
